import { DOCUMENT } from '@angular/common';
import { Directive, ElementRef, HostBinding, Inject, Input, OnInit, Renderer2 } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AvailableBsVersions } from 'ngx-bootstrap/utils';
import { AvailableDrupalVersions, BootstrapVersion, DrupalVersion } from 'pac-api';

import { ColorboxFetchComponent } from '../colorbox-fetch/colorbox-fetch.component';
import { ColorboxInlineComponent } from '../colorbox-inline/colorbox-inline.component';

function nativeWindow(): any {
  return window || {};
}

@Directive({
  selector: 'a[appColorbox],button[appColorbox]',
})
export class ColorboxDirective implements OnInit {

  public get jQuery(): any {
    return nativeWindow().jQuery || {};
  }

  @Input()
  public appColorbox: {[key: string]: any} = {};

  @Input('href')
  @HostBinding('href')
  public href: string;

  constructor(
    private element: ElementRef<HTMLAnchorElement|HTMLButtonElement>,
    private bsModal: BsModalService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    @Inject(BootstrapVersion) private bsVersion: AvailableBsVersions,
    @Inject(DrupalVersion) private drupalVersion: AvailableDrupalVersions,
  ) { }

  public ngOnInit(): void {
    if (this.element.nativeElement instanceof HTMLButtonElement) {
      this.element.nativeElement.type = 'button';
    }

    if (this.bsVersion === 'bs3' && this.jQuery.fn.colorbox) {
      this.colorbox();
    } else if (this.bsVersion === 'bs4' || this.bsVersion === 'bs5') {
      this.modal();
    }
  }

  private colorbox(): void {
    const Drupal = window['Drupal'] || {};
    const settings = Drupal.settings || {};
    const colorbox = settings.colorbox || {};
    const ColorboxSettings = {...colorbox, ...this.appColorbox};
    const iframe = 'iframe' in ColorboxSettings && ColorboxSettings.iframe;
    const inline = 'inline' in ColorboxSettings && ColorboxSettings.inline;

    if (inline) {
      if ('href' in ColorboxSettings) {

      } else {
        ColorboxSettings.href = this.href;
      }
    } else {
      const url = new URL(this.href, document.baseURI || window.location.origin);

      this.href = url.toString();

      if (iframe) {
        url.searchParams.set('iframe', 'true');
      } else {
        url.searchParams.set('modal', 'true');
      }

      ColorboxSettings.href = url.toString();
    }

    this.jQuery(this.element.nativeElement).colorbox(ColorboxSettings);
  }

  private modal(): void {
    const inline = 'inline' in this.appColorbox && this.appColorbox.inline;
    const iframe = 'iframe' in this.appColorbox && this.appColorbox.iframe;

    if (inline) {
      if ('href' in this.appColorbox) {

      } else {
        this.appColorbox.href = this.href;
      }
    } else {
      const url = new URL(this.href, document.baseURI || window.location.origin);

      this.href = url.toString();

      if (iframe) {
        url.searchParams.set('iframe', 'true');
      } else {
        url.searchParams.set('modal', 'true');
      }

      this.appColorbox.href = url.toString();
    }

    this.renderer.listen(this.element.nativeElement, 'click', (event: MouseEvent) => {
      event.preventDefault();

      if (inline) {
        const hash = this.appColorbox.href[0] == '#' ? this.appColorbox.href : (new URL(this.appColorbox.href)).hash;
        const content = this.document.querySelector(hash).outerHTML;
        this.bsModal.show(ColorboxInlineComponent, { class: 'modal-lg', initialState: { Content: content } });
      } else {
        const url = new URL(this.appColorbox.href);
        this.bsModal.show(ColorboxFetchComponent, { class: 'modal-lg',initialState: { Href: url } });
      }
    });
  }
}
